import Api from "@/services/Api";

export default {
  save(modulo, path, params) {
    return Api().post(`/${modulo}/${path}/`, params);
  },
  update(modulo, path, params) {
    return Api().put(`/${modulo}/${path}/${params.id}` + "/", params);
  },
};
